import type {EmailRegistrationChallenge} from '@reados/contracts';
import {ApiError} from './api';

/** These verify errors explicitly confirm that the pending proof has been consumed. */
export function emailRegistrationRequiresLogin(action:'login'|'request'|'verify',error:unknown){
 return action==='verify'&&error instanceof ApiError&&(error.code==='EMAIL_ACCOUNT_CREATED'||error.code==='EMAIL_SESSION_CHANGED');
}

/** Timers are derived from the server receipt; they do not extend code validity. */
export function emailRegistrationTimers(challenge:EmailRegistrationChallenge,now=Date.now()){
 const expiresAt=Date.parse(challenge.expiresAt),resendAfter=Date.parse(challenge.resendAfter);
 if(!challenge.challengeId||!Number.isFinite(expiresAt)||!Number.isFinite(resendAfter))throw new Error('邮箱验证信息无效，请返回后重试。');
 return {expiresIn:Math.max(0,Math.ceil((expiresAt-now)/1000)),resendIn:Math.max(0,Math.ceil((resendAfter-now)/1000))};
}

export function registrationTimeLabel(seconds:number){
 return `${Math.floor(seconds/60)}:${String(seconds%60).padStart(2,'0')}`;
}

export interface AuthOperation {id:number;revision:number}
/** Keep a cancelled operation serialized until its HTTP response has settled. */
export class AuthOperationScope {
 private revision=0;
 private serial=0;
 private pending:AuthOperation|null=null;
 begin():AuthOperation|null{
  if(this.pending)return null;
  return this.pending={id:++this.serial,revision:this.revision};
 }
 current(operation:AuthOperation){return this.pending?.id===operation.id&&operation.revision===this.revision;}
 invalidate(){this.revision++;}
 finish(operation:AuthOperation){
  if(this.pending?.id!==operation.id)return false;
  this.pending=null;return true;
 }
}
